import { render, staticRenderFns } from "./ChemicalsCategories.vue?vue&type=template&id=2458413a"
import script from "./ChemicalsCategories.vue?vue&type=script&lang=js"
export * from "./ChemicalsCategories.vue?vue&type=script&lang=js"
import style0 from "./ChemicalsCategories.vue?vue&type=style&index=0&id=2458413a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports